import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import './CookiePopup.css';

const CookiePopup = () => {
    const [isVisible, setIsVisible] = useState(false);

    useEffect(() => {
        const consent = localStorage.getItem('cookieConsent');
        if (!consent) {
            setIsVisible(true);
        }
    }, []);

    const handleAccept = () => {
        localStorage.setItem('cookieConsent', 'accepted');
        setIsVisible(false);
    };

    const handleDeny = () => {
        localStorage.setItem('cookieConsent', 'denied');
        setIsVisible(false);
    };

    if (!isVisible) return null;

    return (
        <div className="cookie-popup-overlay">
            <div className="cookie-popup-container">
                <p className="cookie-popup-text">
                    By clicking “Accept All”, you agree to the storing of cookies on your device to enhance site navigation, analyze site usage, and assist in our marketing efforts. View our <Link to="/privacy-policy" className="cookie-privacy-link" target="_blank" rel="noopener noreferrer">Privacy Policy</Link> for more information.
                </p>
                <div className="cookie-popup-buttons">
                    <button className="cookie-btn cookie-btn-deny" onClick={handleDeny}>Deny</button>
                    <button className="cookie-btn cookie-btn-accept" onClick={handleAccept}>Accept</button>
                </div>
            </div>
        </div>
    );
};

export default CookiePopup;
